<template>
  <el-dialog title="添加出行人信息模版"
             :visible.sync="travellerTemplateVisible"
             :showtravellerTemplate="showtravellerTemplate"
             @close="closeTravellerTemplate()">
    <el-form ref="resverationModifyForm"
             label-width="80px">
      <div v-if="this.modifyChecked.length !== 0"
           class="show-check-info">
        当前所选信息:
        <div style="display: inline; color: #ff5421"
             v-for="(item, index) in this.modifyChecked"
             :key="index">
          {{ item }}，
        </div>
      </div>
      <el-form-item label="模版名称:">
        <el-input style="width: 30%"
                  maxlength="8"
                  show-word-limit
                  size="mini"
                  v-model="travellerModifyName"></el-input>
      </el-form-item>

      <div class="check-box-class">填写要求</div>
      <el-form-item label-width="2%">
        <span style="display: block; margin-right: 10px">是否下单必填:</span>
        <el-radio-group size="small"
                        v-model="travellerModifyMustFillIn">
          <el-radio :label="1">是（完整填写信息后才可以下单）</el-radio>
          <el-radio :label="0">否（不影响下单，可随时补充信息）</el-radio>
        </el-radio-group>

        <span style="display: block; margin-right: 10px">填写份数:</span>
        <el-radio-group size="small"
                        v-model="travellerModifyOneOrEveryOne">
          <el-radio style="margin-bottom: 20px"
                    :label="0">多个写1份（例：1笔订单买了3份，只需要填写1个出行人信息）</el-radio>
          <el-radio :label="1">每人1份 （例：1笔订单买了3份，则需填写3个出行人信息）</el-radio>
        </el-radio-group>
      </el-form-item>

      <div class="check-box-class">出行信息</div>
      <el-form-item label-width="2%">
        <el-checkbox-group v-model="checked_temp_id_list">
          <el-checkbox v-for="(item, id) of travellerInfor"
                       :key="id"
                       :label="item.id">{{ item.name }}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <div class="check-box-class">证件信息</div>
      <el-form-item label-width="2%">
        <el-checkbox-group v-model="checked_temp_id_list">
          <el-checkbox v-for="(item, id) of credentialType"
                       :key="id"
                       :label="item.id"
                       @change="selectCredential(item.id)">{{ item.name }}</el-checkbox>
        </el-checkbox-group>
        <!-- v-show="item.content" -->
        <div class="crdential-more-info"
             v-for="(item, index) of credential_select_data"
             :key="index"
             :label="item">
          <span>{{ item.name }}:</span>
          <el-checkbox-group v-model="checked_cerdential_id_list">
            <!-- 同步点击的数据 -->
            <el-checkbox v-for="(i, id) of item.content"
                         :key="id"
                         :label="i.id">{{ i.name }}</el-checkbox>
          </el-checkbox-group>
        </div>
      </el-form-item>
      <!-- 学生信息，暂时无 -->
      <div v-show="studentInfor.length != 0"
           class="check-box-class">
        学生信息
      </div>
      <el-form-item label-width="2%">
        <el-checkbox-group v-model="checked_temp_id_list">
          <el-checkbox v-for="(item, index) of studentInfor"
                       :key="index"
                       :label="item.id">{{ item.name }}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>

    <div slot="footer"
         class="dialog-footer">
      <el-button size="mini"
                 @click="cancelModifyVisible">取 消</el-button>
      <el-button size="mini"
                 v-if="this.button_type == 1"
                 type="primary"
                 @click="submitTravellerTemplate">确 定</el-button>
      <el-button v-if="this.button_type == 2"
                 type="primary"
                 @click="submitReviseTravellerTemplate">修 改</el-button>
    </div>
  </el-dialog>
</template>

<script>
const demandFillIN = [
  { name: '下单必填', type: 'boolean', id: 27 },
  { name: '填写份数目', type: 'boolean', id: 28 },
]
const travellerInfor = [
  { name: '国籍', type: 'text', id: 29 },
  { name: '出生地', type: 'text', id: 30 },
  { name: '所在地', type: 'text', id: 41 },
  { name: '姓名', type: 'text', id: 31 },
  { name: '姓名拼音', type: 'text', id: 32 },
  { name: '手机号', type: 'num', id: 35 },
  // { name: "境外手机号", type: "num", id: 36 },
  { name: '电子邮箱', type: 'text', id: 40 },
  { name: '出生日期', type: 'date', id: 33 },
  { name: '性别', type: 'boolean', id: 34 },
  { name: '身高', type: 'text', id: 37 },
  { name: '体重', type: 'text', id: 38 },
  { name: '鞋码', type: 'text', id: 39 },
]
const credentialType = [
  {
    name: '身份证',
    type: 'num',
    id: 0,
    select: [],
    content: [
      { name: '证件号', type: 'num', id: 100 },
      { name: '证件有效期', type: 'date', id: 101 },
      { name: '证件签发地', type: 'text', id: 102 },
    ],
  },
  {
    name: '护照',
    type: 'text',
    id: 1,
    select: [],
    content: [
      { name: '证件号', type: 'num', id: 200 },
      { name: '证件有效期', type: 'date', id: 201 },
      { name: '证件签发地', type: 'text', id: 202 },
    ],
  },
  // {
  //   name: "港澳通行证",
  //   type: "text",
  //   id: 3,
  //   select: [],
  //   content: [
  //     { name: "证件有效期", type: "date", id: 301 },
  //     { name: "证件签发地", type: "text", id: 302 },
  //   ],
  // },
  // {
  //   name: "台湾通行证",
  //   type: "text",
  //   id: 4,
  //   select: [],
  //   content: [
  //     { name: "证件有效期", type: "date", id: 401 },
  //     { name: "证件签发地", type: "text", id: 402 },
  //   ],
  // },
  // { name: "入台证", type: "text", id: 5 },
  // { name: "港澳往返内地通行证", type: "text", id: 6 },
  // { name: "台湾往返内地通行证", type: "text", id: 7 },
  // { name: "港澳居民居住证", type: "text", id: 8 },
  // { name: "台湾居民居住证", type: "text", id: 9 },
  // { name: "台胞证", type: "text", id: 10 },
  // { name: "回乡证", type: "text", id: 11 },
  // { name: "军官证", type: "text", id: 12 },
  // { name: "警官证", type: "text", id: 13 },
  // { name: "士兵证", type: "text", id: 14 },
  // {
  //   name: "中国驾照",
  //   type: "text",
  //   id: 15,
  //   select: [],
  //   content: [
  //     { name: "证件有效期", type: "date", id: 1501 },
  //     { name: "接受罚单地址", type: "date", id: 1502 },
  //     { name: "准驾车型", type: "text", id: 1503 },
  //     { name: "初次领证日期", type: "text", id: 1504 },
  //     { name: "有效起始日期", type: "text", id: 1505 },
  //   ],
  // },
  // { name: "户口本", type: "text", id: 16 },
  // { name: "出生证明", type: "text", id: 17 },
  // { name: "外国人永久居留（身份）证", type: "text", id: 18 },
  // { name: "其他证件", type: "text", id: 19 },
]
const studentInfor = [
  // { name: "学校省份", type: "num", id: 20 },
  // { name: "学校名称", type: "num", id: 21 },
  // { name: "学号", type: "num", id: 22 },
  // { name: "学制", type: "num", id: 23 },
  // { name: "入学年份", type: "num", id: 24 },
  // { name: "优惠段（始）", type: "num", id: 25 },
  // { name: "优惠段（终）", type: "num", id: 26 },
]

export default {
  name: 'traveller-template-modify',
  data() {
    return {
      current_template_id: this.traveller_template_id,
      button_type: 1,
      travellerModifyName: '',
      travellerModifyMustFillIn: 0,
      travellerModifyOneOrEveryOne: 1,

      modifyChecked: [],
      demandFillIN: demandFillIN, // 填写要求的数据 源
      travellerInfor: travellerInfor, // 出行人信息的数据 源
      credentialType: credentialType, // 证件信息的数据 源
      credential_select_data: [], // 证件内的可选项数据 credential_select_data
      studentInfor: studentInfor, // 学生信息
      // 已选的 一级 元素id
      checked_temp_id_list: this.temp_id_list,
      // 已选的证件 元素
      checked_cerdential_id_list: this.cerdential_id_list,
      // 提交的数据
      templateSubmit: [],

      travellerTemplateVisible: this.showtravellerTemplate,
    }
  },
  watch: {
    showtravellerTemplate: {
      handler(value) {
        this.travellerTemplateVisible = value
      },
      immediate: true,
    },
    temp_id_list: {
      handler(value) {
        this.checked_temp_id_list = value
      },
      immediate: true,
    },
    cerdential_id_list: {
      handler(value) {
        this.selectCredential()
        this.checked_cerdential_id_list = value
      },
      immediate: true,
    },
  },
  props: {
    traveller_template_id: Number,
    showtravellerTemplate: false,
    temp_id_list: Array,
    cerdential_id_list: Array,
  },
  methods: {
    // 勾选证件时,显示证件的可选项
    selectCredential(id) {
      console.log(this.checked_cerdential_id_list)
      this.credential_select_data = [] // 变动时清空
      for (let content_id of this.checked_temp_id_list) {
        for (let item of this.credentialType) {
          if (item.id == content_id) {
            this.credential_select_data.push(item)
          }
        }
      }
    },
    // 关闭模版选择对话况
    closeTravellerTemplate() {
      this.$emit('update:showtravellerTemplate', false)
      // 模版名称
      this.travellerModifyName = ''
      // 已选的 源
      this.checked_temp_id_list = []
      // 已选的证件 元素
      this.checked_cerdential_id_list = []
      this.credential_select_data = []
      this.templateSubmit = []
    },
    cancelModifyVisible() {},

    // 添加 出行人模版
    submitTravellerTemplate() {
      if (this.travellerModifyName == '') {
        this.$notify({
          title: '注意',
          message: '模版名称不能为空',
          type: 'warning',
        })
        return
      } else {
        for (let id of this.checked_temp_id_list) {
          // 出行信息的添加
          for (let item of this.travellerInfor) {
            if (item.id == id) {
              this.templateSubmit.push(item)
            }
          }
          // 证件信息的添加
          for (let item of this.credentialType) {
            if (item.id == id) {
              this.templateSubmit.push(item)
              // 证件 更多信息的 添加,不等于就弹出
              if (item.content) {
                for (let content of item.content) {
                  //indexOf() 方法可返回某个指定的字符串值在字符串中首次出现的位置。
                  // 将content删除，仅保留select作为模版
                  if (
                    this.checked_cerdential_id_list.indexOf(content.id) != -1
                  ) {
                    item.select.push(content)
                    // delete item.content;
                  }
                }
              }
            }
          }
          // 学生信息
          for (let item of this.studentInfor) {
            if (item.id == id) {
              this.templateSubmit.push(item)
            }
          }
        }

        let template_traveller = {}
        template_traveller.templateName = this.travellerModifyName
        template_traveller.mustFillIn = this.travellerModifyMustFillIn
        template_traveller.fillInOneOrEveryOne =
          this.travellerModifyOneOrEveryOne

        template_traveller.template = this.templateSubmit
        // 发送请求
        this.$http
          .post('/add_traveller_template', template_traveller)
          .then((res) => {
            const { errno, errmsg } = res.data
            if (errno == '0') {
              this.$notify({
                title: '成功',
                message: errmsg,
                type: 'success',
              })
              // 发送一个事件出去
              this.$emit('changeTravellerTemplate')
              // 关闭对话框
              this.travellerTemplateVisible = false
              // 清除数据
              this.travellerModifyName = ''
              this.travellerModifyMustFillIn = 0
              this.travellerModifyOneOrEveryOne = 0
              this.checked_temp_id_list = []
            }
          })
      }
    },

    // 修改出行人模版 - 提交修改
    submitReviseTravellerTemplate() {
      for (let id of this.checked_temp_id_list) {
        // 已选 的出行基本信息 添加到提交列表
        for (let item of this.travellerInfor) {
          if (item.id == id) {
            this.templateSubmit.push(item)
          }
        }
        // 已选的证件信息  添加到提交列表
        for (let item of this.credentialType) {
          if (item.id == id) {
            this.templateSubmit.push(item)
            // 证件 可选信息 添加 到,不等于就弹出
            //indexOf() 方法可返回某个指定的字符串值在字符串中首次出现的位置。
            // 将content删除，仅保留select作为模版
            if (item.content) {
              for (let content of item.content) {
                //
                if (this.checked_cerdential_id_list.indexOf(content.id) != -1) {
                  item.select.push(content)

                  // delete item.content;
                }
              }
            }
          }
        }
        // 学生信息
        for (let item of this.studentInfor) {
          if (item.id == id) {
            this.templateSubmit.push(item)
          }
        }
      }
      // 发送请求
      let change_template_data = {}
      change_template_data.id = this.traveller_template_id
      change_template_data.templateName = this.travellerModifyName
      change_template_data.fillInOneOrEveryOne =
        this.travellerModifyOneOrEveryOne
      change_template_data.mustFillIn = this.travellerModifyMustFillIn
      change_template_data.template = this.templateSubmit
      this.$http
        .post('/change_traveller_template', change_template_data)
        .then((res) => {
          console.log(res)
          const { data, errno, errmsg } = res.data
          if (errno == '0') {
            this.$notify({
              title: '成功',
              message: errmsg,
              type: 'success',
            })
          } else if (errno == '4103') {
            this.$notify({
              title: '警告',
              message: errmsg,
              type: 'warning',
            })
            return
          }
        })

      // 关闭对话框
      this.travellerTemplateVisible = false
      // 发送一个事件出去
      this.$emit('changeTravellerTemplate')
      // 清除数据
      this.travellerModifyName = ''
      this.travellerModifyMustFillIn = 0
      this.travellerModifyOneOrEveryOne = 0
      this.checked_temp_id_list = []
    },
  },
}
</script>

<style>
.crdential-more-info {
  padding: 0 10px;
  margin-bottom: 5px;
  border-radius: 5px;
  border: 1px dashed #ff5421;
}
</style>